<template>
    <div>
        <v-card>
            <v-toolbar color="secondary" dark>
                <v-toolbar-title>
                    UPT Analytics
                </v-toolbar-title>
            </v-toolbar>
            <v-toolbar >
                <v-combobox :items="boxdash" v-model="dashboard" :item-value="'id'" :item-text="'name'" hide-details
                    label="Select Dashboard"></v-combobox>
                <v-spacer></v-spacer>
                <v-spacer></v-spacer>
                <v-spacer></v-spacer>
                <v-spacer></v-spacer>
                <v-spacer></v-spacer>
                <v-spacer></v-spacer>
                <v-spacer></v-spacer>
                <v-combobox :items="typeBy" v-model="type" class="mr-2" :item-value="'id'" :item-text="'text'" hide-details
                    label="Select Type Order"></v-combobox>
                <v-combobox :items="orderBy" v-model="order" hide-details
                    label="Select Order By" class="mr-2"></v-combobox>
                <v-text-field
                    v-if="dashboard.id == 11"
                    label="Rolling Date"
                    v-model="rollingDate"
                    @change="changeRollingDate"
                    dense
                    class="mr-2"
                    v-mask="'####-##-##'"
                    :append-outer-icon="direction == 1 ? 'mdi-arrow-right-bold':'mdi-arrow-left-bold'"
                    @click:append-outer="changeDirection(!direction)"
                    hide-details
                ></v-text-field>    
                <v-text-field
                    v-if="dashboard.id != 11"
                    label="Start Date"
                    v-model="startDate"
                    @change="changeDateStart"
                    dense
                    class="mr-2"
                    v-mask="'####-##-##'"
                    hide-details
                ></v-text-field>
                <v-text-field
                    v-if="dashboard.id != 11"
                    label="End Date"
                    v-model="endDate"
                    @change="changeDateEnd"
                    dense
                    v-mask="'####-##-##'"
                    hide-details
                ></v-text-field>
            </v-toolbar>
            <div>
                <view_general_dashboard :typeBy="type" :order="order" v-if="dashboard.id == 1 || dashboard == null"></view_general_dashboard>
                <view_shifts_dashboard :typeBy="type" :order="order" v-if="dashboard.id == 2"/>
                <view_drivers_dashboard :typeBy="type" :order="order" v-if="dashboard.id == 3"/>
                <view_region_dashboard :typeBy="type" :order="order" v-if="dashboard.id == 4" ></view_region_dashboard>
                <view_customers_dashboard :typeBy="type" :order="order" v-if="dashboard.id == 5"></view_customers_dashboard>
                <view_truck_dashboard :typeBy="type" :order="order" v-if="dashboard.id == 6"></view_truck_dashboard>
                <view_trailer_dashboard :typeBy="type" :order="order" v-if="dashboard.id == 7"></view_trailer_dashboard>
                <view_yard_dashboard :typeBy="type" :order="order" v-if="dashboard.id == 8"></view_yard_dashboard>
                <view_station_dashboard :typeBy="type" :order="order" v-if="dashboard.id == 9"></view_station_dashboard>
                <view_terminal_dashboard :typeBy="type" :order="order" v-if="dashboard.id == 10"></view_terminal_dashboard>
                <view_maintenance_dashboard :typeBy="type" :order="order" v-if="dashboard.id == 11" :direction="directionName"></view_maintenance_dashboard>
            </div>
        </v-card>
    </div>
</template>

<script>
import moment from 'moment';
import { mask } from 'vue-the-mask';
import view_general_dashboard from "@/components/DashBoard/General.vue";
import view_drivers_dashboard from "@/components/DashBoard/Drivers.vue";
import view_customers_dashboard from "@/components/DashBoard/Customer.vue";
import view_shifts_dashboard from "@/components/DashBoard/Shift.vue";
import view_region_dashboard from "@/components/DashBoard/Region.vue";
import view_truck_dashboard from "@/components/DashBoard/Truck.vue";
import view_trailer_dashboard from "@/components/DashBoard/Trailer.vue";
import view_yard_dashboard from "@/components/DashBoard/Yard.vue";
import view_station_dashboard from "@/components/DashBoard/Station.vue";
import view_terminal_dashboard from "@/components/DashBoard/Terminal.vue";
import view_maintenance_dashboard from "@/components/DashBoard/Maintenance.vue";
export default {
    directives: { mask },
    name:'dashboard',
    components:{
        view_general_dashboard,
        view_drivers_dashboard,
        view_customers_dashboard,
        view_shifts_dashboard,
        view_region_dashboard,
        view_truck_dashboard,
        view_trailer_dashboard,
        view_yard_dashboard,
        view_station_dashboard,
        view_terminal_dashboard,
        view_maintenance_dashboard
    },
    data: function () {
        return {
            typeBy:['Alphabetic','Amount'],
            directionName:'FROM-END',
            order:null,
            type:null,
            direction:0,
            rollingDate:moment().format('YYYY-MM-DD'),
            orderBy:[
                { id:'asc',text:'Ascending'},
                { id:'desc',text:'Descending'},
            ],
            startDate:moment().startOf('year').format('YYYY-MM-DD'),
            endDate: moment().format('YYYY-MM-DD'),
            year:2024,
            years: [2019, 2020, 2021, 2022, 2023, 2024],
            dashboard: null,
            boxdash: [
                { 'id': 1, 'name': 'General  Dashboard' },
                { 'id': 2, 'name': 'Shifts   Dashboard' },
                { 'id': 3, 'name': 'Drivers  Dashboard' },
                { 'id': 4, 'name': 'Regions  Dashboard' },
                { 'id': 5, 'name': 'Customer Dashboard' },
                { 'id': 6, 'name': 'Truck    Dashboard' },
                { 'id': 7, 'name': 'Trailer  Dashboard' },
                { 'id': 8, 'name': 'Yard     Dashboard' },
                { 'id': 9, 'name': 'Station  Dashboard' },
                { 'id': 10, 'name':'Terminal Dashboard' },
                { 'id': 11, 'name':'Maintenance Trailer Dashboard' },
            ],
        }
    },
    watch: {
        $route: {
            immediate: true,
            handler() {
                document.title = 'Dashboard';
            }
        },
    },
    mounted() {
        this.order = this.orderBy[0];
        this.type = this.typeBy[0];
        this.dashboard = this.boxdash[10];
        this.$store.state.analytics.StartTime = moment().startOf('year').format('YYYY-MM-DD');
        this.$store.state.analytics.EndTime = moment().format('YYYY-MM-DD');
        this.$store.state.analytics.RollingDate =  moment().format('YYYY-MM-DD');
    },
    methods: {
        changeDirection(dir){
            this.direction =  dir;
            if(this.direction){
                this.directionName = "FROM-START";
            }else{
                this.directionName = "FROM-END";
            }
            console.log(this.directionName);
        },
        changeRollingDate(){
            this.$store.state.analytics.RollingDate = this.rollingDate;
        },
        changeDateStart(){
            this.$store.state.analytics.StartTime = this.startDate;
            console.log(this.$store.state.analytics.StartTime)
        },
        changeDateEnd(){
            this.$store.state.analytics.EndTime = this.endDate;
            console.log(this.$store.state.EndTime.StartTime)
        }
    }
};
</script>
